import { Component, OnInit, ElementRef, ViewChild, AfterViewInit, Renderer2, Injectable, Output, Input, EventEmitter } from '@angular/core';
import { Router } from "@angular/router";
import { ActivatedRoute } from '@angular/router';
import { connect, Room, createLocalTracks, LocalTrack, LocalVideoTrack, ConnectOptions, Participant, RemoteTrack, RemoteAudioTrack, RemoteVideoTrack, RemoteParticipant, RemoteTrackPublication } from 'twilio-video';
import { HttpClient } from '@angular/common/http';
import { ReplaySubject, Observable } from 'rxjs';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatPaginator, MatTableDataSource } from '@angular/material';
import { debounceTime } from 'rxjs/operators';
import { Subscription } from 'rxjs';

import { DeviceService } from './DeviceService';
import { DeviceSelectComponent } from '../device-select/device-select.component';

export type Devices = MediaDeviceInfo[];

function getQueryParameters(location: Location): Map<string, Array<string>> {
  return (location.search.split('?')[1] || '').split('&').reduce((queryParameters, keyValuePair) => {
    let [key, value] = keyValuePair.split('=');
    key = decodeURIComponent(key);
    value = decodeURIComponent(value);
    queryParameters.set(key, (queryParameters.get(key) || []).concat([value]));
    return queryParameters;
  }, new Map());
}

export interface NamedRoom {
  id: string;
  name: string;
  maxParticipants?: number;
  participantCount: number;
}

export type Rooms = NamedRoom[];

@Component({
  selector: 'app-twilio-video-rxq',
  templateUrl: './twilio-video-rxq.component.html',
  styleUrls: ['./twilio-video-rxq.component.css']
})
export class TwilioVideoRxqComponent implements OnInit {
  @ViewChild('preview') previewElement: ElementRef;
  @ViewChild('previewRemote') previewElementRemote: ElementRef;
  @ViewChild('list') listRef: ElementRef;
  @ViewChild('videoSelect') video: DeviceSelectComponent;
  @Output('participantsChanged') participantsChanged = new EventEmitter<boolean>();
  @Output('leaveRoom') leaveRoom = new EventEmitter<boolean>();
  @Output() settingsChanged = new EventEmitter<MediaDeviceInfo>();
  @Input('activeRoomName') activeRoomName: string;

  cameraName: string;
  roomId: string;
  clientToken: string;
  debug: boolean;
  settings: boolean;

  get tracks(): LocalTrack[] {
    return this.localTracks;
  }

  get participantCount() {
    return !!this.participants ? this.participants.size : 0;
  }

  get isAlone() {
    return this.participantCount === 0;
  }

  get hasAudioInputOptions(): boolean {
    return this.devices && this.devices.filter(d => d.kind === 'audioinput').length > 0;
  }
  get hasAudioOutputOptions(): boolean {
    return this.devices && this.devices.filter(d => d.kind === 'audiooutput').length > 0;
  }
  get hasVideoInputOptions(): boolean {
    return this.devices && this.devices.filter(d => d.kind === 'videoinput').length > 0;
  }

  isInitializing: boolean = true;

  private videoTrack: LocalVideoTrack;
  private localTracks: LocalTrack[] = [];
  private participants: Map<Participant.SID, RemoteParticipant>;
  private allParticipants: any[];
  private dominantSpeaker: RemoteParticipant;
  public devices: MediaDeviceInfo[] = [];
  private subscription: Subscription;
  private videoDeviceId: string;
  public room: Room;
  public error: Error;
  private localDevices: MediaDeviceInfo[] = [];

  $roomsUpdated: Observable<boolean>;

  private roomBroadcast = new ReplaySubject<boolean>();

  constructor(
    private readonly renderer: Renderer2, private readonly http: HttpClient, private readonly deviceService: DeviceService, private _router: Router, private route: ActivatedRoute) {this.$roomsUpdated = this.roomBroadcast.asObservable();}

  async ngAfterViewInit() {
    if (this.previewElement && this.previewElement.nativeElement) {
      await this.initializeDevice();
    }
  }

  initializePreview(deviceInfo?: MediaDeviceInfo) {

    if (deviceInfo) {
      this.initializeDevice(deviceInfo.kind, deviceInfo.deviceId, deviceInfo);
    } else {
      this.initializeDevice();
    }
  }

  initializeParticipants(participants: Map<Participant.SID, RemoteParticipant>) {
    this.participants = participants;
    if (this.participants) {
      this.allParticipants = [];
      this.participants.forEach(participant => this.registerParticipantEvents(participant));
    }
  }

  finalizePreview() {
    try {
      if (this.videoTrack) {
        this.videoTrack.detach().forEach(element => element.remove());
      }
    } catch (e) {
    }
  }

  private async initializeDevice(kind?: MediaDeviceKind, deviceId?: string, deviceIn?: MediaDeviceInfo) {
    if (deviceId != null) {
      try {
        this.isInitializing = true;

        this.finalizePreview();

        this.localTracks = kind && deviceId
          ? await this.initializeTracks(kind, deviceId)
          : await this.initializeTracks();

        //Feedback
        //this.attachRemoteTrack(this.localTracks.find(t => t.kind === 'video'));

         this.videoTrack = this.localTracks.find(t => t.kind === 'video') as LocalVideoTrack;

        const videoElement = this.videoTrack.attach();
        this.renderer.setStyle(videoElement, 'height', '25%');
        this.renderer.setStyle(videoElement, 'width', '20%');
        this.renderer.setStyle(videoElement, 'border-color', 'white');
        this.renderer.setStyle(videoElement, 'border-style', 'solid');
        this.renderer.setStyle(videoElement, 'position', 'absolute');
        this.renderer.setStyle(videoElement, 'top', '10px');
        this.renderer.setStyle(videoElement, 'right', '10px');
        this.renderer.setStyle(videoElement, 'object-fit', 'fill');
        this.renderer.appendChild(this.previewElement.nativeElement, videoElement);
      } finally {
        this.isInitializing = false;

        if (this.clientToken != null) {
          this.CreateRoom(this.roomId, this.localTracks)
        }
      }
    }
  }

  private initializeTracks(kind?: MediaDeviceKind, deviceId?: string) {
     if (kind) {
      switch (kind) {
        case 'audioinput':
          return createLocalTracks({ audio: { deviceId }, video: true });
        case 'videoinput':
          return createLocalTracks({ audio: true, video: { deviceId } });
      }
    }

    return createLocalTracks({ audio: true, video: true });
  }


  private async getAuthToken() {
    const token = this.clientToken;

    return token;
  }

  getAllRooms() {
    return this.http
      .get<Rooms>('api/video/rooms')
      .toPromise();
  }

  CreateRoomRandom(): void {
    this.CreateRoom(this.roomId, this.localTracks)
  }

  nudge() {
    this.roomBroadcast.next(true);
  }

  async CreateRoom(name: string, tracks: LocalTrack[]) {
    const token = this.clientToken;

    let room: Room = null;
    try {
      room =
        await connect(
          token, {
            name,
            tracks,
            dominantSpeaker: true,
            maxAudioBitrate: 16000,
            preferredVideoCodecs: [{ codec: 'VP8', simulcast: true }],
            bandwidthProfile: {
              video: {
                dominantSpeakerPriority: 'high',
                mode: 'collaboration',
                clientTrackSwitchOffControl: 'auto',
                contentPreferencesMode: 'auto'
              }
            }
          } as ConnectOptions);
    } catch (error) {
      this.error = new Error(`Unable to connect to Room: ${error.message}`);
    }

    this.room = room;

    this.subscription =
      this.deviceService
        .$devicesUpdated
        .pipe(debounceTime(550))
        .subscribe(async deviceListPromise => {
          this.devices = await deviceListPromise;
          this.handleDeviceAvailabilityChanges();
        });

    if (this.room.participants) {
      this.initializeParticipants(this.room.participants);
    }

    this.registerRoomEvents();
    return room;
  }

  DisconnectFromRoom(): void {
    this.room.disconnect();
  }

  clear() {
    if (this.participants) {
      this.participants.clear();
    }
  }


  add(participant: RemoteParticipant) {
    if (this.participants && participant) {
      this.participants.set(participant.sid, participant);
      this.registerParticipantEvents(participant);
    }
  }

  remove(participant: RemoteParticipant) {
    if (this.participants && this.participants.has(participant.sid)) {
      this.participants.delete(participant.sid);
    }
  }

  loudest(participant: RemoteParticipant) {
    this.dominantSpeaker = participant;
  }

  onLeaveRoom() {
    this.leaveRoom.emit(true);
  }

  private registerParticipantEvents(participant: RemoteParticipant) {
    if (participant) {

      this.allParticipants.push(participant);

      participant.tracks.forEach(publication => this.subscribe(publication));
      participant.on('trackPublished', publication => this.subscribe(publication));
      participant.on('trackUnpublished',
        publication => {
          if (publication && publication.track) {
            this.detachRemoteTrack(publication.track);
          }
        });
    }
  }

  private subscribe(publication: RemoteTrackPublication | any) {
    if (publication && publication.on) {
      publication.on('subscribed', track => this.attachRemoteTrack(track));
      publication.on('unsubscribed', track => this.detachRemoteTrack(track));
    }
  }

  private attachRemoteTrack(track: RemoteTrack) {
    if (this.isAttachable(track)) {
      const element = track.attach();
      this.renderer.data.id = track.sid;
      this.renderer.setStyle(element, 'margin-left', '2.5%');

      this.renderer.setStyle(element, 'height', '100%');
      this.renderer.setStyle(element, 'width', '105%');

      this.renderer.setStyle(element, 'position', 'absolute');
      this.renderer.setStyle(element, 'top', '0px');
      this.renderer.setStyle(element, 'left', '-35px');
      this.renderer.setStyle(element, 'object-fit', 'fill');

      this.renderer.appendChild(this.listRef.nativeElement, element);
      this.participantsChanged.emit(true);
    }
  }

  private detachRemoteTrack(track: RemoteTrack) {
    if (this.isDetachable(track)) {
      track.detach().forEach(el => el.remove());
      this.participantsChanged.emit(true);
    }
  }

  private isAttachable(track: RemoteTrack): track is RemoteAudioTrack | RemoteVideoTrack {
    return !!track &&
      ((track as RemoteAudioTrack).attach !== undefined ||
        (track as RemoteVideoTrack).attach !== undefined);
  }

  private isDetachable(track: RemoteTrack): track is RemoteAudioTrack | RemoteVideoTrack {
    return !!track &&
      ((track as RemoteAudioTrack).detach !== undefined ||
        (track as RemoteVideoTrack).detach !== undefined);
  }

  private handleDeviceAvailabilityChanges() {
    if (this.devices && this.devices.length && this.video && this.video.selectedId) {
      let videoDevice = this.devices.find(d => d.deviceId === this.video.selectedId);
      if (!videoDevice) {
        videoDevice = this.devices.find(d => d.kind === 'videoinput');
        if (videoDevice) {
          this.video.selectedId = videoDevice.deviceId;
          this.onSettingsChanged(videoDevice);
        }
      }
    }
  }

  async onSettingsChanged(deviceInfo: MediaDeviceInfo) {
    if (deviceInfo) {
      this.initializeDevice(deviceInfo.kind, deviceInfo.deviceId, deviceInfo);
    } else {
      this.initializeDevice();
    }
  }

  private registerRoomEvents() {
    this.room
      //.on('disconnected',
      //  (room: Room) => room.localParticipant.tracks.forEach(publication => this.detachLocalTrack(publication.track)))
      .on('participantConnected',
      (participant: RemoteParticipant) => this.initializeParticipants(this.room.participants)
    );
      //  (participant: RemoteParticipant) => this.participants.add(participant))
      //.on('participantDisconnected',
      //  (participant: RemoteParticipant) => this.participants.remove(participant))
      //.on('dominantSpeakerChanged',
      //  (dominantSpeaker: RemoteParticipant) => this.participants.loudest(dominantSpeaker));
  }

   debugClick(): void {
     this.debug = !this.debug;
  }

  settingsClick(): void {
    this.settings = !this.settings;
  }

  async LoadCam() {
    try {


    const constraints = {
      video: true,
      audio: true
    };

    const mediaDevices = await navigator.mediaDevices.getUserMedia(constraints).then(x => { return navigator.mediaDevices.enumerateDevices() }) //navigator.mediaDevices.enumerateDevices();
    const devices = ['audioinput', 'audiooutput', 'videoinput'].reduce((options, kind) => {
      return options[kind] = mediaDevices.filter(device => device.kind === kind);
    }, [] as Devices);

    this.localDevices = devices;
    this.devices = devices;

    } catch (error) {
      this.subscription =
        this.deviceService
          .$devicesUpdated
          .pipe(debounceTime(350))
          .subscribe(async deviceListPromise => {
            this.devices = await deviceListPromise;
            this.handleDeviceAvailabilityChanges();
          });
    }

    var foundCam: MediaDeviceInfo = this.findCam(this.devices, this.cameraName);
    if (foundCam) {
    await this.initializeDevice(foundCam.kind, foundCam.deviceId, foundCam);
    }
  }

  findCam(media: MediaDeviceInfo[], CamName: string): MediaDeviceInfo{

    return media.find(x => {
      var replaceName: string = x.label.replace("(", "").replace(")", "").replace(/[^g-z]/gi, '')
      if (CamName.replace(/[^g-z]/gi, '') === replaceName.replace(/[^g-z]/gi, '')) {
        return true;
      }
    })
}

  ngOnInit() {

    this.route.params.subscribe(params => {

      this.cameraName = params['CamearaName'];
      this.clientToken = params['AccessToken'];
      this.roomId = params['RoomId'];
    });

    this.LoadCam();
      }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/twilio-video-rxq/twilio-video-rxq.component.ts